<template>
  <Posts :object="object" :params="params" />
</template>

<script>
import {defineComponent} from "vue"
import Posts from "@/modules/post/pages/posts/components/posts/Posts"
import Drafts from "@/modules/post/pages/posts/services/Drafts"

export default defineComponent({
  name: "ArticlesDrafts",
  components: {
    Posts
  },
  setup() {
    let object = new Drafts()

    let params = {
      title: "Все черновики статей",
      h1: "Черновики статей",
      page: "articles_drafts",
      type_ids: [15],
      channel_id: getChannelId(),
    }

    function getChannelId() {
      return 1
    }

    return {
      object,
      params,
    }
  }
})
</script>

<style scoped>

</style>
